export const VUEX_TOAST_SHOW = 'VUEX_TOAST_SHOW'
export const VUEX_TOAST_HIDE = 'VUEX_TOAST_HIDE'

export const VUEX_TOAST_ADD = 'VUEX_TOAST_ADD'
export const VUEX_TOAST_CLEAR_ALL = 'VUEX_TOAST_CLEAR_ALL'
export const VUEX_TOAST_CLEAR_ALL_PERSISTENT = 'VUEX_TOAST_CLEAR_ALL_PERSISTENT'
export const VUEX_TOAST_REMOVE = 'VUEX_TOAST_REMOVE'
export const VUEX_TOAST_PROCCESS = 'VUEX_TOAST_PROCCESS'
export const VUEX_TOAST_CYCLE_COMPLETE = 'VUEX_TOAST_CYCLE_COMPLETE'
